import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

export type SequencesGetLinkParams =
  /**
   * PremiereProPage
   * Landing page specifically for the Premiere Pro UXP Integration
   * /sequences (root path)
   */
  {
    page: 'sequences';
    accountId?: string;
  };

export const getLinkForSequences = (
  params: SequencesGetLinkParams
): ValidHref => {
  const pathname: ValidHref = '/sequences';
  const searchParams: { a?: string } = {};

  // ... ?a=:accountId
  if ('accountId' in params && params.accountId) {
    searchParams.a = toCondensedUUID(params.accountId);
  }

  return createUrl({
    pathname,
    searchParams,
  });
};

export const isSequencesPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  return pathname === '/sequences';
};
